"use strict";

angular.module("internal.exams").controller("InternalExamAutoNumbers", [
    "$scope",
    "EXAutoNum",
    "$rootScope",
    "Resource",
    "Cache",
    function($scope, EXAutoNum, $rootScope, Resource, Cache) {
        $scope.AutoNums = [];

        EXAutoNum.get().then(function(AutoNums) {
            $scope.AutoNums = AutoNums.records;
        });

        $scope.columns = [
            {
                label: "Format",
                field: "formatName",
                link: {
                    state: "internal.exams.administrative.autonumber",
                    params: [
                        {
                            name: "examAutoNumID",
                            field: "id"
                        }
                    ]
                }
            },

            {
                label: "Exam Type(s)",
                field: "examTypes"
            },

            {
                label: "Next Number",
                field: "nextNumber"
            },

            {
                label: "Last Modified",
                field: "modifiedOnUtc",
                type: "datetime"
            },
            {
                label: "Modified By",
                field: "modifiedByFullName"
            }
        ];
    }
]);
